<template>
  <div>
    <div class="outgoing-detail">
      <Toast />

      <div class="card">
        <table style="width: 100%">
          <thead>
            <!-- HEADER -->
            <div class="card">
              <div class="p-grid">
                <div class="p-col-1 image">
                  <img src="/assets/images/logo.png" />
                </div>
                <div
                  class="p-col-10"
                  style="margin-top: -10px; margin-left: -5px"
                >
                  <h4 style="font-size: 15px; line-height: 0.5">
                    <b>MODE FASHION GROUP</b>
                  </h4>
                  <h6 style="font-size: 11px; line-height: 0.5">
                    {{ outlet.name }}
                  </h6>
                  <h6 style="font-size: 11px; line-height: 0.5">
                    Telp. (061) 6643780
                  </h6>
                </div>
              </div>
            </div>
            <div class="border-header" style="margin-bottom: 30px"></div>
            <!-- akhir header -->
          </thead>
          <tbody>
            <h4 class="title" style="margin-bottom: 20px; margin-top: -20px">
              <b style="font-size: 14px">Laporan Kelompok Barang</b>
            </h4>

            <div class="p-grid">
              <div class="p-col-11 p-m-auto">
                <table class="table-bordered text-center detail-bon">
                  <thead class="thead-light" style="font-size: 11px">
                    <tr>
                      <th class="text-center">Kelompok Barang</th>
                      <th class="text-center">Total Barang</th>
                      <th class="text-center">Jumlah Terjual</th>
                      <th class="text-center">Mutasi Masuk</th>
                      <th class="text-center">Mutasi Keluar</th>
                      <th class="text-center">Stok Barang</th>
                      <th class="text-center">Stok Price</th>
                    </tr>
                  </thead>
                  <h1 v-if="items.length != total_data" class="p-m-auto">
                    LOADING...MOHON TUNGGU
                  </h1>
                  <tbody style="font-size: 11px">
                    <tr v-for="(an_item, k) in items" :key="k">
                      <td>{{ an_item.category + ' - ' + an_item.name }}</td>
                      <td>{{ an_item.total_item }}</td>
                      <td>{{ an_item.total_sell }}</td>
                      <td>{{ an_item.mutasi_masuk }}</td>
                      <td>{{ an_item.mutasi_keluar }}</td>
                      <td>{{ an_item.stok_item }}</td>
                      <td>{{ an_item.stock_price | number }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <div class="card" style="margin-top: -33px">
              <div class="p-grid p-p-flex-column text-center">
                <div class="p-col-6 detail-bon">
                  <label style="margin-bottom: 70px; font-size: 12px"
                    >Supervisor Toko</label
                  >
                  <div
                    style="
                      border-top: 1px solid black;
                      width: 50%;
                      margin: auto;
                    "
                  ></div>
                </div>
                <div class="p-col-6 detail-bon">
                  <label
                    style="margin-bottom: 70px; font-size: 12px"
                    v-if="detail.summary.type == 'RETURN'"
                    >Penerima Gudang</label
                  >
                  <label style="margin-bottom: 70px; font-size: 12px" v-else
                    >Penerima Outlet</label
                  >
                  <div
                    class="detail-bon"
                    style="border-top: 1px solid black; width: 50%"
                  ></div>
                </div>
              </div>
            </div> -->
          </tbody>
        </table>
      </div>
      <!-- akhir class card -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      items: true,
      ModeLogo: undefined,
      outlet: null,
      total_data: this.$route.query.total_data
    }
  },
  mounted() {
    this.getAuthUser()
    this.getItems()
  },
  methods: {
    getAuthUser() {
      this.getOutlets()
    },

    async getOutlets() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets/${this.user.outlet_id}`
        )
        if (response.status === 200) {
          this.outlet = response.data.data.outlets
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      }
    },

    async getItems() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/report_category?limit=${this.total_data}&page=1`
        )
        if (response.status === 200) {
          this.items = response.data.data.category

          setTimeout(() => {
            window.print()
          }, 500)

          setTimeout(() => {
            window.history.back()
          }, 500)
        }
      } catch (error) {
        console.error('Error fetching items:', error)
      }
    }
  }
}
</script>
<style scoped lang="scss">
table {
  -fs-table-paginate: paginate;
}
.outgoing-detail {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

.border-header {
  border-top: 2px solid black;
  width: 95%;
  margin-top: -4vh;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.image {
  margin-top: -7px;
  width: 63px;
}

.title {
  text-align: center;
}

.detail-bon {
  margin-left: auto;
  margin-right: auto;
}

th,
td {
  padding: 5px;
}
</style>
